/**
 * Governance Enforcement Service
 * AIDLC Administrative Backend
 *
 * API calls for governance enforcement log and post-checks.
 */

import apiClient from './api';

export interface GovernanceAuditEntry {
  id: string;
  agentId: string;
  taskType: 'chat' | 'go-do-it';
  subject: string;
  rulesEvaluated: number;
  rulesMatched: number;
  matchedRuleIds: string[];
  verdict: 'allowed' | 'blocked' | 'approval-needed';
  blockedReason: string | null;
  injectedContextCount: number;
  postCheckCount: number;
  timestamp: string;
}

export interface GovernancePostCheck {
  id: string;
  type: 'require-review' | 'require-test' | 'quality-gate' | 'step-sequence' | 'escalation-scan';
  description: string;
  assignedAgent: string | null;
  originAgent: string;
  originTask: string;
  auditRecordId: string;
  status: 'pending' | 'completed' | 'waived';
  completedAt: string | null;
  completedBy: string | null;
  createdAt: string;
}

const GOV_PATH = '/governance';

export async function getEnforcementLog(limit = 50, offset = 0): Promise<{
  entries: GovernanceAuditEntry[];
  total: number;
}> {
  const response = await apiClient.get(`${GOV_PATH}/enforcement-log`, {
    params: { limit, offset },
  });
  return response.data;
}

export async function getPostChecks(status?: string): Promise<GovernancePostCheck[]> {
  const response = await apiClient.get<GovernancePostCheck[]>(`${GOV_PATH}/post-checks`, {
    params: status ? { status } : {},
  });
  return response.data;
}

export async function completePostCheck(
  id: string,
  action: 'completed' | 'waived',
  completedBy = 'Neo'
): Promise<GovernancePostCheck> {
  const response = await apiClient.put<GovernancePostCheck>(
    `${GOV_PATH}/post-checks/${id}`,
    { action, completedBy }
  );
  return response.data;
}
